import React from 'react'
import { Link } from 'react-router-dom'
import useScrollVisibility from 'hooks/useScrollVisibility'
import junior from 'assets/images/junior.jpg'
import piacievski from 'assets/images/piacievski.jpg'
import petrassi from 'assets/images/petrassi.jpg'
import teixeira from 'assets/images/teixeira.jpg'

const data = [
  {
    name: 'Dr. José Macias Nogueira Junior',
    specialization: 'Direito Empresarial',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: junior,
    oab: '31.848',
    link: '/lawyer/jose-macias-nogueira-junior/PR123456',
  },
  {
    name: 'Dr. Diego Pulzatto Piacievski',
    specialization: 'Direito Civil e Penal',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: piacievski,
    oab: '76.292',
    link: '/lawyer/diego-pulzatto-piacievski/PR567890',
  },
  {
    name: 'Dra. Renata Fontes Pereira Teixeira',
    specialization: 'Direito da Família e Civil',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: teixeira,
    oab: '60.469',
    link: '/lawyer/renata-fontes-pereira-teixeira/PR987654',
  },
  {
    name: 'Dra. Renata Lima Petrassi',
    specialization: 'Recuperação de Crédito',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: petrassi,
    oab: '57.496',
    link: '/lawyer/renata-lima-petrassi/PR654321',
  },
]

const OurLawyers = () => {
  const [isVisible, sectionRef] = useScrollVisibility('lawyers-section')

  return (
    <section ref={sectionRef} className='flex w-full items-center justify-center'>
      <ul className='m-4 flex w-11/12 items-baseline gap-8 overflow-x-auto md:m-8 md:grid md:w-11/12 md:grid-cols-4'>
        {data.map((lawyer, index) => (
          <li
            key={index}
            className={`flex min-w-52 flex-col items-center justify-center gap-4 text-center md:w-auto ${
              isVisible ? 'animate-scale-in' : 'opacity-0'
            }`}
          >
            {/* <Link to={lawyer.link}> */}
            <img
              src={lawyer.image}
              alt={lawyer.name}
              className='w-full scale-95 cursor-pointer transition-all duration-500 hover:scale-100'
              loading='lazy'
            />
            {/* </Link> */}
            <div className='flex w-full flex-col text-lg'>
              <h3 className='font-semibold'>{lawyer.name}</h3>
              <p className='mb-2'>{`OAB/PR ${lawyer.oab}`}</p>
              <p className='mb-2'>{`Especialista em ${lawyer.specialization}`}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default OurLawyers
